export const SET_LOADING = 'SET_LOADING'
export const SET_ALERT_CONFIG = 'SET_ALERT_CONFIG'
export const MODAL_LAYER_SET = 'MODAL_LAYER_SET'
export const MODAL_LAYER_REMOVE = 'MODAL_LAYER_REMOVE'
export const MODAL_LAYER_PUSH = 'MODAL_LAYER_PUSH'
export const QRIS_BANNER_VISIBLE = 'QRIS_BANNER_VISIBLE'
export const QRIS_MODAL = 'QRIS_MODAL'
